module.exports = __webpack_public_path__ + "img/emoji_dayan.86663752.png";